import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { X } from 'lucide-react';
const approaches = ['El ayuno extremo de los lunes solo eleva más tu cortisol y te hincha por puro estrés metabólico.', 'Los tés laxantes deshidratan el colon pero no eliminan la inflamación real en tus tejidos.', 'Matarse en el gimnasio cuando estás inflamada genera más estrés oxidativo y ensancha más tu cintura.', 'Sustituir comidas por batidos azucarados dispara tu insulina, bloqueando la quema de energía.'];
export function FailedApproaches() {
  return <section className="py-16 md:py-24 px-6" data-id="element-21">
      <div className="max-w-4xl mx-auto" data-id="element-22">
        <FadeIn data-id="element-23">
          <h3 className="text-3xl md:text-4xl font-bold text-center mb-12 text-charcoal" data-id="element-24">
            Lo que has probado NO funciona (y por qué)
          </h3>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-25">
          {approaches.map((text, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-26">
              <div className="flex items-start gap-4 p-6 rounded-2xl bg-white border border-red-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-27">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-red-50 flex items-center justify-center mt-1" data-id="element-28">
                  <X className="w-5 h-5 text-terracotta" data-id="element-29" />
                </div>
                <p className="text-warmgray leading-relaxed" data-id="element-30">{text}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}